"use client";

import { useEffect, useState, type ReactNode } from "react";

import { FUOCO_HOME } from "@/components/home/stile";
import { PRIMA_SCELTA_ROTAZIONE, scegliSchede } from "@/lib/servizi-rotazione";

/** La griglia e il piede di «I nostri servizi · Il metodo». Riceve le 28
 *  schede già rese dal server e ne mostra quattro: le altre restano nel
 *  DOM con `hidden`. L'ordine delle quattro è quello della scelta (CSS
 *  `order`), e a ogni nuovo gruppo le schede rientrano con l'animazione
 *  `oiSvEntra` (spenta col movimento ridotto). */
export function SchedeARotazione({ schede }: { schede: ReactNode[] }) {
  const [scelti, setScelti] = useState<number[]>(PRIMA_SCELTA_ROTAZIONE);
  const [giro, setGiro] = useState(0);

  useEffect(() => {
    // Il sorteggio dopo l'idratazione: nel render darebbe un gruppo diverso
    // da quello del server (errore d'idratazione), e sul server non
    // cambierebbe a ogni visita.
    // eslint-disable-next-line react-hooks/set-state-in-effect -- sorteggio a caso, solo nel browser
    setScelti(scegliSchede(null));
    setGiro(1);
  }, []);

  return (
    <>
      <div
        aria-live="polite"
        className="grid grid-cols-1 gap-[22px] px-4 pt-5 pb-6 min-[681px]:grid-cols-2 min-[681px]:px-9 min-[681px]:pt-7 min-[681px]:pb-8 min-[1281px]:grid-cols-4"
      >
        {schede.map((scheda, i) => {
          const posto = scelti.indexOf(i);
          return (
            <div
              key={posto < 0 ? i : `${i}-${giro}`}
              hidden={posto < 0}
              data-entra={posto >= 0 && giro > 0 ? "" : undefined}
              style={posto >= 0 ? { order: posto } : undefined}
              className="flex min-w-0"
            >
              {scheda}
            </div>
          );
        })}
      </div>
      <div className="mx-4 flex flex-wrap items-center justify-between gap-4 border-t border-rule pt-4 pb-5 min-[681px]:mx-9 min-[681px]:pt-[18px] min-[681px]:pb-[26px]">
        <p className="m-0 font-mono text-[11px] tracking-[0.08em] text-sommesso uppercase">
          28 schede · 14 servizi · AI · Cibernetica · OSINT · Chi siamo
        </p>
        <button
          type="button"
          onClick={() => {
            setScelti((prima) => scegliSchede(prima));
            setGiro((g) => g + 1);
          }}
          className={`group inline-flex cursor-pointer items-center gap-3 border-0 bg-transparent p-0 font-sans text-corpo font-semibold text-mare transition-colors hover:text-segnale focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-segnale ${FUOCO_HOME}`}
        >
          <i
            aria-hidden
            className="grid size-9 place-items-center rounded-full border border-mare transition-colors duration-300 group-hover:border-segnale group-hover:bg-segnale group-hover:text-carta"
          >
            <svg
              viewBox="0 0 24 24"
              className="size-4 fill-none stroke-current stroke-[1.6] transition-transform duration-500 group-hover:-rotate-180"
            >
              <path d="M20 12a8 8 0 1 1-2.3-5.6" />
              <path d="M20 4v5h-5" />
            </svg>
          </i>
          Altre quattro schede
        </button>
      </div>
    </>
  );
}
